import classNames from "classnames";
import React from "react";
import { actions } from "react-redux-form";
import _ from "underscore";

import { RadioButton, Errors } from "../../../../core/atoms/rrf";
import { CommonProps, EnquiryFormSection } from "./common";
import { FormProgressIcon } from "./formProgressIcon";

interface OwnProps {
  dispatch: any;
}

export class IndependenceLevelSelect extends EnquiryFormSection<OwnProps> {
  protected shouldUpdateValidity(oldProps: CommonProps, newProps: CommonProps) {
    return !_.isEqual(oldProps.formState.independenceLevel, newProps.formState.independenceLevel);
  }

  protected syncValidity(formState: Forms.EnquiryForm) {
    this.props.dispatch(actions.setErrors(this.props.model, { required: formState.independenceLevel == null }));
  }

  public render() {
    const { model, className, id } = this.props;

    return (
      <section id={id} className={classNames("independence-level-select", className)}>
        <header>
          <FormProgressIcon model={model} />
          <h2>How much guiding would you like?</h2>
        </header>

        <div className="enquiry-form-question enquiry-form-radio-select">
          <Errors model={model} messages={{ required: "Please select an option" }} />

          <RadioButton
            model={model}
            id={`independence-level-${IndependenceLevel.FullyGuided}`}
            name="independence-level"
            value={IndependenceLevel.FullyGuided}
            label="Fully guided"
            subLabel="I'd like a local guide whenever possible"
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value, 10)}
          />

          <RadioButton
            model={model}
            id={`independence-level-${IndependenceLevel.PartiallyGuided}`}
            name="independence-level"
            value={IndependenceLevel.PartiallyGuided}
            label="Partially guided"
            subLabel="I'd like a local guide if needed, but I also want to explore some things independently"
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value, 10)}
          />

          <RadioButton
            model={model}
            id={`independence-level-${IndependenceLevel.FullyIndependent}`}
            name="independence-level"
            value={IndependenceLevel.FullyIndependent}
            label="Fully independent"
            subLabel="I'm happy to do most things independently"
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value, 10)}
          />

          <RadioButton
            model={model}
            id={`independence-level-${IndependenceLevel.Unknown}`}
            name="independence-level"
            value={IndependenceLevel.Unknown}
            label="I haven't decided"
            subLabel="Our local experts will advise you which activities are best done with a guide"
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value, 10)}
          />
        </div>
      </section>
    );
  }
}